import { render, staticRenderFns } from "./totalGarbage.vue?vue&type=template&id=675f48fe&scoped=true"
import script from "./totalGarbage.vue?vue&type=script&lang=js"
export * from "./totalGarbage.vue?vue&type=script&lang=js"
import style0 from "./totalGarbage.vue?vue&type=style&index=0&id=675f48fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675f48fe",
  null
  
)

export default component.exports